import script from "./SeeAllRewards.vue?vue&type=script&setup=true&lang=js"
export * from "./SeeAllRewards.vue?vue&type=script&setup=true&lang=js"

import "./SeeAllRewards.vue?vue&type=style&index=0&id=6b4be37e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b4be37e"]])

export default __exports__